import type { WbsClient } from '@bldsoft/cappie/api/wbs'
import type { API } from '@setplex/tria-api'
import type { AdapterDefaults } from '../../index.h'

import { payload } from '@bldsoft/cappie/rest'
import { DEFAULT_PAGE_SIZE } from '../../constants/generic'
import { formatChannel } from '../tv/tv.format'
import { formatTvBundle } from './tvBundles.format'

export function use(
  client: WbsClient,
  tvBundles: API['tvBundles'],
  _api: API,
  defaults: AdapterDefaults
): void {
  // GET /v3/bundles/channels
  tvBundles.getTvBundlesFx.use(
    async ({
      page,
      sortBy,
      sortOrder = defaults.sortOrder,
      count = defaults.count || DEFAULT_PAGE_SIZE,
      channelId,
    }) => {
      const bundles = await payload(
        client.get.api.v3.bundles.channels({
          query: {
            page: page || undefined,
            count: count || undefined,
            'sort-by': sortBy || undefined,
            'sort-order': sortOrder || undefined,
            channelId: channelId || undefined,
          },
        })
      )
      return {
        ...bundles,
        content: bundles.content.map(formatTvBundle),
      }
    }
  )

  // GET /v3/bundles/channels/{bundleId}
  tvBundles.getTvBundleInfoBaseFx.use(async ({ bundleId }) => {
    const bundle = await payload(client.get.api.v3.bundles.channels(bundleId)())
    return formatTvBundle(bundle)
  })

  // GET /v3/bundles/channels/{id}/content
  tvBundles.getTvBundleContentFx.use(
    async ({ bundleId, page, count = defaults.count || DEFAULT_PAGE_SIZE }) => {
      const channels = await payload(
        client.get.api.v3.bundles.channels(bundleId).content({
          query: { page: page || undefined, count: count || undefined },
        })
      )

      return {
        ...channels,
        content: channels.content.map(formatChannel),
      }
    }
  )

  /**************** $TvBundleWithContent *******************/
  // to paginate over - paginateTvBundleWithContent
  tvBundles.loadTvBundleWithContentFx.use(async ({ count, bundleId }) => {
    const bundleInfo = await tvBundles.loadTvBundleInfoForContent({ bundleId })
    const channels = [
      ...(
        await tvBundles.paginateTvBundleWithContent({
          page: 0,
          count,
          bundleId: Number(bundleId),
        })
      ).content,
    ]

    return {
      ...bundleInfo,
      channels,
    }
  })
  /**************** $TvBundleWithContent *******************/
}
